import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getOfferList, GetOfferListParams, getOffers, GetOffersParams } from '../clients/gateway.api';
import { validateOffer } from '../clients/order.api';

export const offers = createQueryKeys('offers', {
    list: (params: GetOfferListParams) => ({
        queryKey: [{ params }],
        queryFn: () => getOfferList(params),
    }),
    pagination: (params: GetOffersParams) => ({
        queryKey: [{ params }],
        queryFn: () => getOffers(params),
    }),
    validation: ({ offerId, offer }) => ({
        queryKey: [offerId],
        queryFn: () => validateOffer({ offerId, offer }),
    }),
});
